import xhr from '../plugins/axios.js';

const classeAction = {
  getClasseTypes() {
    return xhr.get('api/admin/classe/type');
  },
};

export default classeAction;
